import { RequireAuth } from '../../auth/RequiredAuth';
import { Link, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { DsgvoTable } from '../../components/SetupInstructions/DsgvoTable';
import { DataProtectionInfoTable } from './DataProtectionInfoTable';

export function DataProtectionPage() {
  return (
    <RequireAuth>
      <Stack sx={{ pt: 3, pb: '1em' }} spacing={2}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          Data storage
        </Typography>
        <Paper sx={{ padding: '1rem' }}>
          <Typography variant="h4">
            Data processing of the participants (test participants)
          </Typography>
          <DsgvoTable />
        </Paper>
        <Paper sx={{ padding: '1rem' }}>
          <Typography variant="h4">Data storage</Typography>
          <DataProtectionInfoTable
            tableDescriptor={{
              columns: {
                dataType: { label: 'Data type', flex: 1 },
                storageService: { label: 'Service', flex: 2 },
                storageRegion: { label: 'Region/location', flex: 1 },
              },
              data: [
                {
                  dataType: 'Test configuration',
                  storageService: 'AWS DynamoDB',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Public media pool (images)',
                  storageService: 'AWS S3 + AWS DynamoDB (metadata)',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Images uploaded by the user',
                  storageService: 'AWS S3 + AWS DynamoDB (metadata)',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Recorded results',
                  storageService: 'AWS DynamoDB',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Processed results (CSV file)',
                  storageService: 'AWS S3',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Protocol data',
                  storageService: (
                    <>
                      AWS Cloudwatch
                      <br />
                      DCB Monitoring (Hetzner/Strato)
                    </>
                  ),
                  storageRegion: (
                    <>
                      eu-central-1 (Frankfurt)
                      <br />
                      Berlin/Karlsruhe/Nuremberg
                    </>
                  ),
                },
              ],
            }}
          />
        </Paper>
        <Paper sx={{ padding: '1rem' }}>
          <Typography variant="h4">Data processing services</Typography>
          <DataProtectionInfoTable
            tableDescriptor={{
              columns: {
                dataType: { label: 'Tyoe of data', flex: 1 },
                storageService: { label: 'Service', flex: 2 },
                storageRegion: { label: 'Region/location', flex: 1 },
              },
              data: [
                {
                  dataType: 'Test configuration',
                  storageService: 'AWS AppSync/AWS Lambda',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Public media pool (images)',
                  storageService: 'AWS S3 API, AWS App Sync, AWS Lambda',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Images uploaded by the user',
                  storageService: 'AWS S3 API, AWS App Sync, AWS Lambda',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Recording the results',
                  storageService: 'AWS App Sync, AWS Lambda',
                  storageRegion: 'eu-central-1 (Frankfurt)',
                },
                {
                  dataType: 'Processing result',
                  storageService: 'DeZIM Server',
                  storageRegion: 'Berlin',
                },
              ],
            }}
          />
        </Paper>
        <Paper sx={{ padding: '1rem' }}>
          <Typography variant="h4">How long the data is stored</Typography>
          <DataProtectionInfoTable
            tableDescriptor={{
              columns: {
                dataType: { label: 'Type of data', flex: 1 },
                storageDuration: { label: 'Service', flex: 2 },
              },
              data: [
                {
                  dataType: 'Test configuration',
                  storageDuration: 'Unlimited',
                },
                {
                  dataType: 'Public media pool (images)',
                  storageDuration: 'Unbegrenzt',
                },
                {
                  dataType: 'Images uploaded by the user',
                  storageDuration: 'Unlimited',
                },
                {
                  dataType: 'Recorded results',
                  storageDuration: 'currently unlimited, target value 5 years',
                },
                {
                  dataType: 'Processed results (CSV file)',
                  storageDuration: 'currently unlimited, target value 5 years',
                },
                {
                  dataType: 'Protocol data (CloudWatch)',
                  storageDuration: 'currently unlimited, target value 2 years',
                },
                {
                  dataType: 'Log data LogStash (DCB Monitoring)',
                  storageDuration: 'currently unlimited, target value 2 years',
                },
              ],
            }}
          />
        </Paper>
        <Paper sx={{ padding: '1rem' }}>
          <Typography variant="h4" mb={1}>
            For what purpose is the data processed
          </Typography>
          <Typography variant="body2">
            For more information please see the{' '}
            <Link href={'https://mindset.dezim-institut.de/'}>
              Participant Information and Data Protection (PIDP)
            </Link>{' '}
            for the use of the MIND.set platform and{' '}
            <Link href={'https://mindset.dezim-institut.de/'}>
              General Terms and Conditions (GTC)
            </Link>{' '}
            for the use of the MIND.set platform
          </Typography>
        </Paper>
      </Stack>
    </RequireAuth>
  );
}
